import React from 'react';
import Button from './UI/button';
import { loginWithGoogle } from '../services/google-authentication.service';
import { GoogleOAuthProvider, useGoogleLogin } from '@react-oauth/google';

const GOOGLE_CLIENT_ID =
  '490963385462-rv5m2k0o1tk7vh1307u6fr2d8g21jklu.apps.googleusercontent.com';

export interface googleLoginProps {
  isSignUp: false;
  loginSuccess: (id: string) => void;
}

function GoogleLoginButton({ isSignUp, loginSuccess }: googleLoginProps) {
  const handleClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    googleAuthenticate();
  };

  const googleAuthenticate = useGoogleLogin({
    onSuccess: async (response: any) => {
      await googleLogin(response.access_token);
    },
    onError: (error: any) => {
      console.error('Error logging in with Google:', error);
    }
  });

  const googleLogin = async (token: any) => {
    const success = await loginWithGoogle(token);
    loginSuccess('google');
  };

  return (
    <Button
      onClick={handleClick}
      fontFamily='rubik'
      variant='dark'
      className='d-flex align-items-center justify-content-center px-1 g-col-6'
      style={{ gap: '8px' }}
    >
      <svg
        width='20'
        height='20'
        viewBox='0 0 20 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M19.8689 10.2281C19.8698 9.54663 19.8117 8.8664 19.6955 8.19482H10.1997V12.046H15.6385C15.5272 12.6611 15.2916 13.2475 14.946 13.7697C14.6004 14.292 14.1518 14.7393 13.6274 15.0848V17.5846H16.8733C18.7739 15.8444 19.8689 13.271 19.8689 10.2281Z'
          fill='white'
        />
        <path
          d='M10.1997 20C12.9169 20 15.2049 19.1139 16.8733 17.5862L13.6274 15.0864C12.7239 15.6947 11.5604 16.0419 10.1997 16.0419C7.57328 16.0419 5.34408 14.2836 4.54693 11.9143H1.20312V14.4906C2.0412 16.1467 3.32629 17.5389 4.91493 18.5118C6.50358 19.4847 8.33324 19.9999 10.1997 20Z'
          fill='white'
        />
        <path
          d='M4.54686 11.914C4.12543 10.6724 4.12543 9.32793 4.54686 8.08639V5.51013H1.20305C0.498032 6.90333 0.130859 8.44096 0.130859 10.0002C0.130859 11.5594 0.498032 13.097 1.20305 14.4902L4.54686 11.914Z'
          fill='white'
        />
        <path
          d='M10.1997 3.95879C11.6356 3.93549 13.0231 4.47429 14.0623 5.45872L16.9362 2.60469C15.1139 0.904883 12.6996 -0.0283412 10.1997 0.000656061C8.33324 0.000740536 6.50358 0.515984 4.91494 1.48886C3.32629 2.46174 2.0412 3.85397 1.20312 5.5101L4.54693 8.08636C5.34408 5.71704 7.57328 3.95879 10.1997 3.95879Z'
          fill='white'
        />
      </svg>
      Log in with Google
    </Button>
    //               <Button
    //   onClick={() => googleAuthenticate()}
    //   className='btn btn-primary mb-4 px-5'
    //   color='dark'
    //   size='sm'
    // >
    //   Login with Google
    // </Button>
  );
}

const LoginWithGoogle: React.FC<any> = ({
  isSignUp,
  loginSuccess
}: googleLoginProps) => (
  <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
    <GoogleLoginButton
      isSignUp={isSignUp}
      loginSuccess={loginSuccess}
    />
  </GoogleOAuthProvider>
);

export default LoginWithGoogle;
